import { imageTypes } from "../../@types/image.types";
import { FILE_PORTAL_URL } from "../../config/config";

const generateImageDialogLink = (image: imageTypes): string => {
	const imageLink = `${FILE_PORTAL_URL}/api/v1/file/${image.filename}`;

	return imageLink;
};

export default generateImageDialogLink;
